import type { I18n } from "@lingui/core";

/** ICU `select` cases for the call-me-back message. `asap` is the default and maps to the required `other` branch. */
export const CALLBACK_TIME_SLOTS = ["asap", "morning", "afternoon", "evening"] as const;

export type CallbackTimeSlot = (typeof CALLBACK_TIME_SLOTS)[number];

export const DEFAULT_CALLBACK_TIME_SLOT: CallbackTimeSlot = "asap";

export const isCallbackTimeSlot = (value: string | null | undefined): value is CallbackTimeSlot =>
  CALLBACK_TIME_SLOTS.includes(value as CallbackTimeSlot);

export const callbackTimeSlotLabel = (i18n: I18n, slot: CallbackTimeSlot): string => {
  switch (slot) {
    case "morning":
      return i18n.t({
        id: "dealer.callMeBack.timeSlot.morning",
        message: "09:00 - 12:00",
        comment: "Option in the call me back form for being called between 09:00 and 12:00",
      });
    case "afternoon":
      return i18n.t({
        id: "dealer.callMeBack.timeSlot.afternoon",
        message: "12:00 - 16:00",
        comment: "Option in the call me back form for being called between 12:00 and 16:00",
      });
    case "evening":
      return i18n.t({
        id: "dealer.callMeBack.timeSlot.evening",
        message: "After 16:00",
        comment: "Option in the call me back form for being called after 16:00",
      });
    default:
      return i18n.t({
        id: "dealer.callMeBack.timeSlot.asap",
        message: "As soon as possible",
        comment: "Default option in the call me back form for being called as soon as possible",
      });
  }
};

/** The sentence sent to the dealer as the contact message body. */
export const callbackMessage = (i18n: I18n, timeSlot: CallbackTimeSlot): string =>
  i18n.t({
    id: "dealer.callMeBack.resolvedMessage",
    message:
      "I would like to be called back {timeSlot, select, morning {between 09:00 and 12:00} afternoon {between 12:00 and 16:00} evening {after 16:00} other {as soon as possible}}.",
    values: { timeSlot },
    comment:
      "The whole message sent to the dealer when the user asks to be called back. 'timeSlot' is the time the user picked; the 'other' branch is the default 'as soon as possible' option",
  });
